import { css } from "styled-components";

// react-date-range ships a light-only theme (react-date-range/dist/theme/default.css).
// Repaint its sheet and day colours from the theme so the calendar follows dark
// mode. Nested under the wrapper, each rule outranks the library one it replaces.
// Assumes the range is filled with `primary` (rangeColors={[theme.primary]}).
export const dateRangeThemeStyles = css`
  .rdrCalendarWrapper {
    background: ${({ theme }) => theme.surfaceElevated};
    color: ${({ theme }) => theme.textMain};
  }

  .rdrWeekDay,
  .rdrMonthName {
    color: ${({ theme }) => theme.textMuted};
  }

  .rdrDayNumber span {
    color: ${({ theme }) => theme.textMain};
  }

  .rdrDayPassive .rdrDayNumber span {
    color: ${({ theme }) => theme.textTertiary};
  }

  .rdrDayDisabled {
    background-color: ${({ theme }) => theme.snow};
  }

  .rdrDayDisabled .rdrDayNumber span {
    color: ${({ theme }) => theme.textDisabled};
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: ${({ theme }) => theme.primary};
  }

  /* Number and today mark on the primary fill take the sheet colour. */
  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: ${({ theme }) => theme.surfaceElevated};
  }

  .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after {
    background: ${({ theme }) => theme.surfaceElevated};
  }
`;
